module.exports = __webpack_public_path__ + "76addb1198cbb7460e55d06ce0b58a24.jpg";